<template>
    <div
        class="metrics-configuration-card"
        data-testid="metrics-configuration-card"
        :class="{ active: isActive, empty: !enabledMetricsLength }"
    >
        <h4 data-testid="metrics-configuration-card-name">
            {{ headerName }}
        </h4>
        <div data-testid="metrics-configuration-card-info">
            <al-icon icon="check" />{{ enabledMetricsLength }} / {{ children?.length || 0 }} metrics
        </div>
    </div>
</template>
<script setup lang="ts">
import { MetricsConfigColumnDefinition } from '@agyletime/performance-utils';
import { computed, defineProps } from 'vue';

interface Props {
    headerName?: string;
    children: MetricsConfigColumnDefinition[];
    isActive?: boolean;
}

const props = defineProps<Props>();

const enabledMetricsLength = computed(() => {
    return props?.children?.filter((m) => m.isSelected)?.length || 0;
});

</script>
<style lang="scss">
@import './style.scss';
</style>